import React, { Component } from "react";
import profile from "../../assets/images/Oval.png";
import { Divider } from "antd";

class TvScreen2 extends Component {
  columnContent = () => (
    <>
      <div className="screen2doctorsDetailsDiv">
        <div className="row qroomstatus2">
          <span class="screen2qdoctorRoom">
            Room No:
            <span class="qdoctor-text-style-1">12</span>
          </span>
          <span class="screen2qdoctorStatus">
            Status:
            <span class="qdoctor-text-style-1">In</span>
          </span>
        </div>
        <div className="screen2qdoctorImgDiv">
          <img alt="" src={profile} class="screen2qdoctorImg" />
        </div>
        <span class="screen2qdoctorname">Dr. Ivan Palmer</span>
        <span class="qdoctorProf">Cardiologist</span>
        <span class="qdoctorExp">Experience: 20 Years</span>
        <span class="qdoctorTimings">Timings:</span>
        <div className="qdocTimings">
          <span class="qdoctorTime">10:00AM-02:00PM</span>
          <span class="qdoctorTime">03:00PM-10:00PM</span>
        </div>
      </div>
      <div className="rowDetails">
        <span class="CurrentNextQ">Current</span>
        <span class="CNQPatientDetails mb-1">Token No: 00129</span>
        <span class="CNQPatientDetails">Name: Nelluri Chaitanya</span>
      </div>
      {/* <div className="DividerLine" /> */}
      <Divider />

      <div className="rowDetails">
        <span class="CurrentNextQ mt-2">Next</span>
        <span class="CNQPatientDetails mb-1">Token No: 00129</span>
        <span class="CNQPatientDetails">Name: Nelluri Chaitanya</span>
      </div>
      {/* <div className="DividerLine" /> */}
      <Divider />

      <div className="rowDetails">
        <span class="CurrentNextQ">Queue</span>
        <span class="CNQPatientDetails mb-1">Token No: 00129</span>
        <span class="CNQPatientDetails">Name: Nelluri Chaitanya</span>
      </div>
    </>
  );
  render() {
    return (
      <div className="tvScreen2">
        <div className="col-md-3 col-lg-4 screenColumn">
          {this.columnContent()}
        </div>
        <div className="col-md-3 col-lg-4 screenColumn">
          {this.columnContent()}
        </div>
        <div className="col-md-3 col-lg-4 screenColumn">
          {this.columnContent()}
        </div>
      </div>
    );
  }
}
export default TvScreen2;
